import React from "react";
import {convertFromRaw, EditorState} from "draft-js";
import Editor from "draft-js-plugins-editor";
import {contentEditorDecorator, plugins} from './content-editor';

class ContentShow extends React.Component {
    render() {
        const { contentData } = this.props;
        const content = JSON.parse(contentData);
        if (!content) return null;

        const editorState = EditorState.createWithContent(convertFromRaw(content), contentEditorDecorator());
        return (
            <Editor
            // blockRenderMap={blockRenderMap}
            // blockStyleFn={getBlockStyle}
            // customStyleMap={styleMap}
            onChange={() => {}}
            editorState={editorState}
            placeholder=""
            ref="editor"
            spellCheck={true}
            plugins={plugins}
            readOnly={true}
        />);
    }
}

export default ContentShow;
